import { Navigate } from 'react-router-dom'

import { PreloadableRouteObject, TFileToRouteMap } from '~/app/models'
import { getRoutesFromMap } from '~/app/utils/lazy'
import { EClientPath } from '~/models/api'

const basicInfoImport = () => import('~/pages/onboarding/basicInfo')
const creatingLibbyImport = () => import('~/pages/onboarding/creatingLibby')
const tryItOutImport = () => import('~/pages/onboarding/tryItOut')

export const onboardingDemoRoutesFileToRouteMap: TFileToRouteMap = {
  onboardingBasicInfo: {
    path: EClientPath.onboardingBasicInfo,
    getImportPromise: basicInfoImport,
  },
  onboardingCreatingLibby: {
    path: EClientPath.onboardingCreatingLibby,
    getImportPromise: creatingLibbyImport,
  },
  onboardingTryItOut: {
    path: EClientPath.onboardingTryItOut,
    getImportPromise: tryItOutImport,
  },
  demoBasicInfo: {
    path: EClientPath.demoBasicInfo,
    getImportPromise: basicInfoImport,
  },
  demoCreatingLibby: {
    path: EClientPath.demoCreatingLibby,
    getImportPromise: creatingLibbyImport,
  },
  demoTryItOut: {
    path: EClientPath.demoTryItOut,
    getImportPromise: tryItOutImport,
  },
}

const onboardingDemoRoutes: PreloadableRouteObject[] = getRoutesFromMap(
  onboardingDemoRoutesFileToRouteMap,
).concat(
  {
    path: EClientPath.demoBase,
    element: <Navigate to={EClientPath.demoBasicInfo} replace />,
  } as PreloadableRouteObject,
  {
    path: EClientPath.onboardingBase,
    element: <Navigate to={EClientPath.onboardingBasicInfo} replace />,
  } as PreloadableRouteObject,
)

export default onboardingDemoRoutes
